import classNames from 'classnames';
import { Badge, Tooltip } from 'components-antd';
import { Icons } from 'pages/Workshop/Icons';

import styles from './styles.module.scss';
import { sortDetails } from 'pages/FormProcess/helper';
import { useSelector } from 'react-redux';
import { getUserId } from 'store/selectors/user';

export const ApproversTooltip = (props) => {
  const { approversStr, pendingApprovers, showingData } = props;

  const userId = useSelector(getUserId);

  const { ShowingAppointmentApproval } = showingData;
  return (
    <Tooltip
      color="#fff"
      trigger="hover"
      placement="topRight"
      overlayClassName={styles.pendingTooltipContainer}
      title={
        <div className={styles.approverTooltipContent}>
          <div className={styles.title}>Pending Approval:</div>
          <div>
            {sortDetails(ShowingAppointmentApproval, 'Id').map((item) => {
              const {
                ApproverName: { FirstName, LastName },
                ApprovalStatus,
                ApproverUserId,
              } = item;

              const isYou = userId && userId === ApproverUserId;

              return (
                <div key={item.Id} className={styles.approverItem}>
                  <div className={styles.name}>{isYou ? 'You' : `${FirstName} ${LastName}`}</div>
                  <Icons
                    variant={
                      ApprovalStatus === 'Approved' ? Icons.GREEN_CHECK_CIRCLE : Icons.PENDING_DULL
                    }
                    className={styles.pendingIcon}
                  />
                </div>
              );
            })}
          </div>
        </div>
      }
    >
      <Badge count={pendingApprovers.length} className={styles.approversBadge}>
        <Icons variant={Icons.PENDING_APPROVAL_BG} className={styles.pendingIcon} />
      </Badge>
    </Tooltip>
  );
};
